enum SolovitPremissions {
  Prem_Solovit_View = 'Prem_Solovit_View',
  Prem_Solovit_Manager = 'Prem_Solovit_Manager',
  Prem_Solovit_Invoices = 'Prem_Solovit_Invoices',
  Prem_Solovit_Reopen_Invoice = 'Prem_Solovit_Reopen_Invoice',
}

export default SolovitPremissions;
